//Core
import React, { useState } from "react"

//Components
import AccordionItem from "./AccordionItem"

//Styles
import style from "./style.module.scss"

const items = [
  {
    title: `Які картки я можу додати в Apple Wallet?`,
    text: `В додатку Apple Pay  можна зареєструвати ПК  Mastercard (окрім Prepaid)`,
  },
  {
    title: `Скільки карток я можу додати в Apple Wallet на одному пристрої?
        `,
    text: `Кількість карток, що можливо токенізувати в одному додатку залежить від типу та моделі пристрою.  Відповідно до інструкції по налаштуванню Apple Pay на Apple Watch Series 3, iPhone X, iPhone 8 і  iPhone 8 Plus можна додати до 12 карток з розрахунку на один пристрій. На більш ранніх моделях можна додати до 8 карток з розрахунку на пристрій. Одну картку можна токенізувати на одному пристрої тільки один раз, два рази одну картку на одному пристрої додати неможливо`,
  },
  {
    title: `Скільки токенів можна створити для однієї картки?`,
    text: `На одному пристрої можна створити тільки один токен для однієї картки. На різних пристроях до однієї картки можна максимально створити 21 токен`,
  },
  {
    title: `Чи можу додати картку іншого банку  в Apple Wallet?`,
    text: `В додаток можна додавати картки будь-яких банків, за умови, що банк підтримує Apple Pay`,
  },
  {
    title: `На яких пристроях я можу 
        додати картки в Apple Wallet?`,
    text: `Додавати картки можна на смартфон, планшет, годинник, комп’ютер MAC`,
  },
  {
    title: `Що робити якщо я загублю мій телефон/ годинник/планшет?`,
    text: `В цілях безпеки необхідно заблокувати пристрій через iCloud, в результаті чого здійснюється блокування токенів`,
  },
  {
    title: `Якщо я передам годинник іншій людині чи будуть працювати токени?`,
    text: `Якщо годинник втратить зв’язок зі смартфоном токени заблокуються`,
  },
  {
    title: `Якщо годинник втратить зв’язок зі смартфоном токени заблокуються?`,
    text: `В даному випадку токени будуть видалені`,
  },
  {
    title: `Якщо я заблокую смартфон через сервіс iCloud, що стане з токенами?`,
    text: `На пристрої буде  заблокований доступ до токенів у додатку Apple Pay`,
  },
  {
    title: `Якщо я заблокував фізичну картку чи буде заблоковано токен в додатку?`,
    text: `При блокуванні фізичної картки токен в додатку Apple Pay, створений до даної картки, буде заблоковано. Тому, якщо картка вкрадена, загублена тощо необхідно заблокувати  платіжну картку, що автоматично  заблокує  токени`,
  },
]

const Accodrion = () => {
  const [openTab, changeTab] = useState(0)

  const handlerOnClick = index =>
    changeTab(prevState => (prevState === index ? null : index))

  return (
    <div className={style.accordion}>
      {items.map((el, index) => (
        <AccordionItem
          key={index}
          show={index === openTab}
          click={handlerOnClick}
          index={index}
          {...el}
        />
      ))}
    </div>
  )
}

export default Accodrion
